import { signal } from '@preact/signals-react';

import type { ProductModel } from '@/entities/product/model';

const cartOpen = signal(false);

const productDetailsOpen = signal(false);
const productDetailsProduct = signal<ProductModel | null>(null);

export const uiStore = {
  // корзина
  cartOpen,
  openCart() { cartOpen.value = true; },
  closeCart() { cartOpen.value = false; },

  // деталка товара (drawer) — ГЛОБАЛЬНОЕ состояние
  productDetailsOpen,
  productDetailsProduct,
  openProductDetails(product: ProductModel) {
    productDetailsProduct.value = product;
    productDetailsOpen.value = true;
  },
  closeProductDetails() {
    productDetailsOpen.value = false;
    productDetailsProduct.value = null;
  },
};